// Customers' views' props, as zod (pages/ux-full components/customers.js EquipmentCard): equipment.list's
// answer as it is, rows and all, with the company's today so the words read right. Not in TOOL_VIEWS yet:
// a chat's "what's due at this customer's" registers EquipmentList there with these props.
import { z } from 'zod';

const Id = z.string().min(1);
const LocalDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

/** One equipment.list row: a piece of equipment at a customer's address. */
export const EquipmentRow = z.object({
  id: Id,
  kind: z.string(),
  make: z.string().nullable(),
  model: z.string().nullable(),
  installedOn: LocalDate.nullable(),
  ageYears: z.int().nullable(),
  retiredAt: z.string().nullable(),
  customer: z.object({ id: Id, name: z.string() }),
  location: z.object({ id: Id, name: z.string().nullable(), line1: z.string(), city: z.string() }),
  warranty: z.object({
    state: z.enum(['covered', 'ended', 'none']),
    until: LocalDate.nullable(),
    lifetime: z.boolean(),
  }),
  lastVisit: z.object({ on: LocalDate, jobId: Id, jobNumber: z.string() }).nullable(),
  serviceDue: z.object({ on: LocalDate, what: z.string() }).nullable(),
});
export type EquipmentRow = z.infer<typeof EquipmentRow>;

/** equipment.list's rows, and the company's today, so "due in 12 days" and "overdue" read right. */
export const EquipmentListProps = z.object({
  today: LocalDate,
  equipment: z.array(EquipmentRow),
});
export type EquipmentListProps = z.infer<typeof EquipmentListProps>;
